<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="800"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar class="indigo">
            <v-icon dark>
              {{ appCurrency.Icon }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Common.Misc.Discount') }}
            </div>

            <div class="text-caption">
              {{ $t('Pos.SelectCouponDialog.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-0">
          <v-container fluid>
            <v-row dense>
              <v-col cols="6">
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row dense>
                    <v-col
                      v-for="(item, index) in couponsPercent"
                      :key="`coupon-percent-${index}`"
                      cols="6"
                    >
                      <v-list
                        class="pb-0 pt-0"
                        two-line
                      >
                        <v-list-item
                          :class="[item.Type === 'P' ? (isDarkMode ? 'green darken-4' : 'green lighten-5') : (isDarkMode ? 'orange darken-4' : 'orange lighten-5'), {'pa-1': !$vuetify.breakpoint.xsOnly}, 'rounded']"
                          class="pa-1"
                          ripple
                          @click="setCoupon(item)"
                        >
                          <v-list-item-avatar v-if="!$vuetify.breakpoint.xsOnly">
                            <v-icon
                              :class="[item.Type === 'P' ? 'green--text' : 'orange--text']"
                              size="36"
                            >
                              {{ item.Type === 'P' ? 'local_offer' : appCurrency.Icon }}
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content :class="[isDarkMode ? 'grey--text text--lighten-2' : 'grey--text text--darken-2']">
                            <v-list-item-title :class="[$vuetify.breakpoint.xsOnly ? 'text-center' : 'text-left']">
                              -{{ item.Type === 'P' ? toFloat(item?.Discount).toFixed(0) + '%' : $options.filters.currency(item.Discount) }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                      </v-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="6">
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row dense>
                    <v-col
                      v-for="(item, index) in couponsFixed"
                      :key="`coupon-percent-${index}`"
                      cols="6"
                    >
                      <v-list
                        class="pb-0 pt-0"
                        two-line
                      >
                        <v-list-item
                          :class="[item.Type === 'P' ? (isDarkMode ? 'green darken-4' : 'green lighten-5') : (isDarkMode ? 'orange darken-4' : 'orange lighten-5'), {'pa-1': !$vuetify.breakpoint.xsOnly}, 'rounded']"
                          class="pa-1"
                          ripple
                          @click="setCoupon(item)"
                        >
                          <v-list-item-avatar v-if="!$vuetify.breakpoint.xsOnly">
                            <v-icon
                              :class="[item.Type === 'P' ? 'green--text' : 'orange--text']"
                              size="36"
                            >
                              {{ item.Type === 'P' ? 'local_offer' : appCurrency.Icon }}
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content :class="[isDarkMode ? 'grey--text text--lighten-2' : 'grey--text text--darken-2']">
                            <v-list-item-title :class="[$vuetify.breakpoint.xsOnly ? 'text-center' : 'text-left']">
                              -{{ item.Type === 'P' ? toFloat(item?.Discount).toFixed(0) + '%' : $options.filters.currency(item.Discount) }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                      </v-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>

            <v-row
              v-if="!!taxGroupCoupons.length &&
                appHasFiscalDocsEnabled &&
                appHasFiscalDocsProvider &&
                appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD &&
                userIsSuperAdmin
              "
              dense
            >
              <v-col cols="12">
                <v-divider class="my-1" />
              </v-col>

              <v-col
                v-for="(item, index) in taxGroupCoupons"
                :key="index"
                :cols="(taxGroupCoupons.length > 1 && index === taxGroupCoupons.length) || (taxGroupCoupons.length === 1) ? 12 : 6"
              >
                <v-list
                  class="pb-0 pt-0"
                  two-line
                >
                  <v-list-item
                    :class="[item.Type === 'P' ? (isDarkMode ? 'green darken-4' : 'green lighten-5') : (isDarkMode ? 'brown darken-3' : 'brown lighten-5'), {'pa-1': !$vuetify.breakpoint.xsOnly}, 'rounded']"
                    class="pa-1"
                    ripple
                    @click="setCoupon(item)"
                  >
                    <v-list-item-avatar v-if="!$vuetify.breakpoint.xsOnly">
                      <v-icon
                        :class="[item.Type === 'P' ? 'green--text' : 'brown--text']"
                        size="36"
                      >
                        {{ item.Type === 'P' ? 'local_offer' : appCurrency.Icon }}
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content :class="[isDarkMode ? 'grey--text text--lighten-2' : 'grey--text text--darken-2']">
                      <v-list-item-title
                        :class="[$vuetify.breakpoint.xsOnly ? 'text-center' : 'text-left']"
                        class="font-weight-bold"
                      >
                        {{ String(item.Custom)?.startsWith('WithVat') ? $t('Common.Misc.With') : String(item.Custom)?.startsWith('WithoutVat') ? $t('Common.Misc.Without') : '' }}

                        <template v-if="String(item.Custom)?.startsWith('TotalWithVat') || String(item.Custom)?.startsWith('TotalWithoutVat')">
                          {{ $t('Common.Misc.Total') }}
                          {{ String(item.Custom)?.startsWith('TotalWithVat') ? $t('Common.Misc.With') : String(item.Custom)?.startsWith('TotalWithoutVat') ? $t('Common.Misc.Without') : '' }}
                          {{ item?.TaxLang || '' }}
                        </template>

                        <template v-else>
                          {{ getTranslatedField(item, 'Name', 'TaxLang', false) }}
                        </template>
                      </v-list-item-title>
                      <v-list-item-title :class="[$vuetify.breakpoint.xsOnly ? 'text-center' : 'text-left']">
                        -{{ item.Type === 'P' ? itoFloat(item?.Discount).toFixed(0) + '%' : $options.filters.currency(item.Discount) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider />
                </v-list>
              </v-col>

              <v-col cols="12">
                <v-divider class="my-1" />
              </v-col>
            </v-row>

            <v-row
              v-if="customEnabled"
              dense
            >
              <v-col
                cols="10"
                sm="5"
              >
                <v-text-field
                  v-model="discountPercent.Discount"
                  :error="discountPercent.Error"
                  :hint="$t('Pos.SelectCouponDialog.Field.DiscountPercent.Hint')"
                  :label="$t('Pos.SelectCouponDialog.Field.DiscountPercent.Label')"
                  clearable
                  hi
                  max="100"
                  min="0"
                  solo
                  step="1"
                  suffix="%"
                  type="number"
                />
              </v-col>

              <v-col
                cols="2"
                sm="1"
              >
                <v-btn
                  class="green mt-2"
                  dark
                  icon
                  @click="setCoupon(discountPercent)"
                >
                  <v-icon dark>
                    add
                  </v-icon>
                </v-btn>
              </v-col>

              <v-col
                cols="10"
                sm="5"
              >
                <v-text-field
                  v-model="discountAmount.Discount"
                  :error="discountAmount.Error"
                  :hint="$t('Pos.SelectCouponDialog.Field.DiscountAmount.Hint')"
                  :label="$t('Pos.SelectCouponDialog.Field.DiscountAmount.Label')"
                  :suffix="appCurrency.Symbol"
                  clearable
                  min="0"
                  solo
                  type="number"
                />
              </v-col>

              <v-col
                cols="2"
                sm="1"
              >
                <v-btn
                  class="orange mt-2"
                  dark
                  icon
                  @click="setCoupon(discountAmount)"
                >
                  <v-icon dark>
                    add
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            text
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {clone, sortBy, toFloat} from '@/lib/helper/helper'
import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata'
import Translatable from '@/mixins/translatable'

export default {
  name      : 'SelectCouponDialog',
  components: {},
  mixins    : [Auth, AppData, Translatable],
  props     : {
    sourceType: {
      type   : [String, Number],
      default: 0
    },
    menuItem: {
      type   : Object,
      default: undefined
    },
    unpaidItems: {
      type   : Array,
      default: undefined
    },
    visible: {
      type   : Boolean,
      default: false
    }
  },
  DataStore: {posCart: 'cart'},
  data() {
    return {
      isDiscountSelected: false,
      discountAmount    : {
        Type    : 'F',
        Name    : 'Coupon',
        Code    : '',
        Discount: '',
        Error   : false
      },
      discountPercent: {
        Type    : 'P',
        Name    : 'Coupon',
        Code    : '',
        Discount: '',
        Error   : false
      }
    }
  },
  computed: {
    FiscalDocsProviderTypeEnum() {
      return FiscalDocsProviderTypeEnum
    },
    isTableOrder() {
      return !!this.posCart?.TableShiftId && !!this.posCart?.TableShift
    },

    orderDiscounts() {
      return this.appConfig?.LOCATION_DATA?.OrderDiscounts || {}
    },

    customEnabled() {
      return (this.orderDiscounts?.CustomEnabled ?? true) && (this.posUser?.Settings?.AllUsers.Permissions.CanAddOrderDiscountCustom ?? true)
    },

    coupons() {
      const coupons = this.orderDiscounts?.Coupons ?? [
        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 5,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 10,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 0.5,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 1,
          RowId   : '',
          Custom  : ''
        },

        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 15,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 20,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 1.5,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 2,
          RowId   : '',
          Custom  : ''
        },

        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 25,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 30,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 2.5,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 3,
          RowId   : '',
          Custom  : ''
        },

        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 40,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 50,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 5,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 10,
          RowId   : '',
          Custom  : ''
        },

        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 75,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: 100,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 15,
          RowId   : '',
          Custom  : ''
        },
        {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: 20,
          RowId   : '',
          Custom  : ''
        }
      ]

      return sortBy(coupons, 'Discount', 'asc')
    },

    couponsPercent() {
      return this.coupons.filter(c => c.Type === 'P')
    },
    couponsFixed() {
      return this.coupons.filter(c => c.Type === 'F')
    },

    cartCoupons() {
      const totals = this.posCart?.Totals || []
      return totals.filter(total => total.Name === 'coupon') || []
    },

    taxGroupCoupons() {
      const vatGroups = this.unpaidItems || []
      const coupons = []
      let totalWith = 0
      let totalWithout = 0

      vatGroups.forEach((vatGroup, index) => {
        totalWith += vatGroup.ItemsTotal
        totalWithout += vatGroup.ItemsTotalNoTax

        coupons.push({
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: vatGroup.ItemsTotal,
          RowId   : '',
          Custom  : `WithVat-${vatGroup.TaxRate}`,
          TaxLang : vatGroup.TaxLang
        })

        coupons.push({
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: vatGroup.ItemsTotalNoTax,
          RowId   : '',
          Custom  : `WithoutVat-${vatGroup.TaxRate}`,
          TaxLang : vatGroup.TaxLang
        })
      })

      if (vatGroups.length > 1) {
        coupons.push({
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: totalWith,
          RowId   : '',
          Custom  : 'TotalWithVat',
          TaxLang : this.$t('Common.Misc.Vat')
        })

        coupons.push({
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: totalWithout,
          RowId   : '',
          Custom  : 'TotalWithoutVat',
          TaxLang : this.$t('Common.Misc.Vat')
        })
      }

      return coupons
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.discountAmount = {
          Type    : 'F',
          Name    : 'Coupon',
          Code    : '',
          Discount: '',
          Error   : false
        }
        this.discountPercent = {
          Type    : 'P',
          Name    : 'Coupon',
          Code    : '',
          Discount: '',
          Error   : false
        }
      } else {
        this.isDiscountSelected = false
      }
    }
  },
  methods: {
    toFloat,
    setCoupon(coupon) {
      if (this.isDiscountSelected) return
      coupon = clone(coupon)

      if (coupon.Discount === '' || isNaN(coupon.Discount) || coupon.Discount <= 0 || (coupon.Type === 'P' && coupon.Discount > 100)) {
        coupon.Error = true
        return
      } else {
        coupon.Error = false
      }

      this.isDiscountSelected = true

      const discountFormatted = parseFloat(coupon.Discount).toLocaleString(this.$i18n.locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      })

      if (this.menuItem) {
        coupon.RowId = this.menuItem?.RowId || ''
        if (coupon.Type === 'P') {
          coupon.Type = 'F'
          coupon.Custom = `${discountFormatted}%`
          const menuItemPriceTotal = parseFloat((((parseFloat(this.menuItem.Price) * parseInt(this.menuItem.Quantity)))).toFixed(2))
          const discountedPrice = parseFloat(((menuItemPriceTotal / 100) * coupon.Discount).toFixed(2))
          coupon.Discount = discountedPrice

          /// TODO: Remove this IF BLOCK in case we fix item discounts for line items in fnb
          if (this.isTableOrder &&
              this.appHasFiscalDocsEnabled &&
              this.appHasFiscalDocsProvider &&
              this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD &&
              discountedPrice === menuItemPriceTotal
          ) {
            coupon.Discount = discountedPrice - 0.01
          }
          /// /////
        } else {
          const menuItemPriceTotal = parseFloat((((parseFloat(this.menuItem.Price) * parseInt(this.menuItem.Quantity)))).toFixed(2))
          const discountedPrice = parseFloat(parseFloat(coupon.Discount).toFixed(2))
          coupon.Custom = this.$options.filters.currency(discountedPrice)

          /// TODO: Remove this IF BLOCK in case we fix item discounts for line items in fnb
          if (this.isTableOrder &&
              this.appHasFiscalDocsEnabled &&
              this.appHasFiscalDocsProvider &&
              this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD &&
              discountedPrice === menuItemPriceTotal
          ) {
            coupon.Discount = discountedPrice - 0.01
            coupon.Custom = this.$options.filters.currency(coupon.Discount)
          }
          /// /////
        }
      } else {
        if (coupon.Type === 'P') {
          if (this.isTableOrder) {
            const cartOrderTotal = parseFloat(this.posCart.SCartTotal) || 0
            const cartCouponsTotal = parseFloat((this.cartCoupons?.reduce((a, b) => parseFloat(a) + parseFloat(b.Discount), 0) || 0))
            const cartSpecialAndExcludedTotal = parseFloat(this.posCart?.ItemsFlat?.filter(item => item.Excluded || (item.SpecialStatus && item.IsSpecial))?.reduce((a, b) => parseFloat(a) + (parseFloat(b.Price) * parseInt(b.Quantity)), 0) || 0)
            const cartOrderTotalWithDiscounts = parseFloat((cartOrderTotal - cartCouponsTotal - cartSpecialAndExcludedTotal).toFixed(2))

            coupon.Type = 'F'
            coupon.Custom = `${discountFormatted}%`
            coupon.Discount = parseFloat(((cartOrderTotalWithDiscounts / 100) * coupon.Discount).toFixed(2))
          } else {
            coupon.Custom = `${discountFormatted}%`
          }
        } else {
          coupon.Custom = this.$options.filters.currency(parseFloat(coupon.Discount))
        }
      }

      coupon.Discount = parseFloat(parseFloat(coupon.Discount).toFixed(2))
      coupon.Code = coupon.Custom ? this.menuItem ? this.menuItem.Name + ' ' : this.$t('Common.Misc.Discount').toLocaleUpperCase(this.$i18n.locale) + ' ' : this.$t('Common.Misc.Discount').toLocaleUpperCase(this.$i18n.locale) + ' '
      coupon.Code += coupon.Custom ? `( ${coupon.Custom} )` : `( ${(coupon.Type === 'P' ? `${parseFloat(coupon.Discount).toFixed(2)}%` : this.$options.filters.currency(coupon.Discount))} )`

      this.$emit('cart:coupon-selected', coupon, this.menuItem)
      this.isVisible = false

      // console.log('setCoupon', coupon, this.menuItem)
    },
    onCancelButtonClick() {
      this.isVisible = false
    }
  }
}
</script>

<style scoped>
:deep(.v-list__tile--link) {
  padding: 0 !important;
}
</style>
